import { Component, OnInit } from '@angular/core';
import {
  Router,
  NavigationEnd,
  NavigationStart,
  NavigationCancel,
  NavigationError,
  Event,
  ActivatedRoute,
} from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { map, filter, mergeMap } from 'rxjs/operators';
import { SpinnerService } from './shared/spinner/spinner.service';

// Google Analytics, sem erros em tempo de execução
declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  loading: boolean;
  contraste: boolean;
  fragment: any;
  queryParams: any;

  constructor(
    private router: Router,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private metaService: Meta,
    private spinnerService: SpinnerService,
  ) {
    // Passive listener para melhorar o scroll.
    document.addEventListener('touchstart', () => { }, { passive: true });

    // Chama serviço de spinner com eventos de router.
    this.router.events.subscribe((routerEvent: Event) => {
      this.verificaEventoDaRota(routerEvent);
    });

    // Ativa/desativa o spinner com inscrição no serviço de spinner.
    this.spinnerService.loading$.subscribe((isLoading) => {
      this.loading = isLoading;
    });

    // Conexão google analytics.
    router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        gtag('config', 'UA-49356531-30', {
          page_path: event.urlAfterRedirects,
        });
      });
  }

  ngOnInit() {

    if (localStorage.getItem('altoContraste') === 'true') {
      this.contraste = true;
    }

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          return this.activatedRoute;
        }),
        map((route) => {
          while (route.firstChild) { route = route.firstChild; }
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => {
          return route.data;
        }),
      )
      .subscribe((event) => {
        this.titleService.setTitle(this.criaTitulo(event));
      });

    this.metaService.addTags([
      { name: 'keywords', content: 'CNCT, Catalogo, Cursos Técnicos' },
      { name: 'description', content: 'Catálogo Nacional de Cursos Técnicos' },
      { name: 'robots', content: 'index' },
    ]);
  }

  criaTitulo(event: any): string {
    if (event.title) {
      if (event.title.startsWith('{{')) {
        const [key, value] = event.title.replace('{{', '').replace('}}', '').split('.');
        // Retorna o valor da chave como título.
        return `${event[key][value]} | CNCT`;
      }
      return `${event.title} | CNCT`;
    }
  }

  /**
   *
   * @param routerEvent um evento de router.
   */
  verificaEventoDaRota(routerEvent: Event): void {
    if (routerEvent instanceof NavigationStart) {
      // Mostra spinner.
      // this.loading = true;
      this.spinnerService.show();
    }

    if (
      routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError
    ) {
      // Oculta spinner.
      // this.loading = false;
      // setTimeout(() => {
      // Oculta o spinner após 300ms.
      // this.loading = false;
      this.spinnerService.hide();
      // }, 300);
    }
  }

  /**
   *
   * @param event de ativar contraste.
   */
  altoContraste(event: boolean) {
    this.contraste = event;
    localStorage.setItem('altoContraste', this.contraste.toString());
  }
}
